(function () {
  'use strict';

  var trigger = document.getElementById('rm-support-trigger');
  var panel = document.getElementById('rm-support-panel');
  var copied = document.getElementById('rm-support-copied');
  if (!trigger || !panel) return;

  function closePanel() {
    panel.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
  }

  function openPanel() {
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  }

  trigger.addEventListener('click', function (e) {
    e.stopPropagation();
    if (panel.hidden) openPanel();
    else closePanel();
  });

  document.addEventListener('click', function (e) {
    if (!panel.contains(e.target) && e.target !== trigger) closePanel();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closePanel();
  });

  panel.querySelectorAll('[data-copy]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var text = btn.getAttribute('data-copy');
      if (!text) return;

      navigator.clipboard.writeText(text).then(function () {
        if (copied) {
          copied.hidden = false;
          setTimeout(function () {
            copied.hidden = true;
          }, 2000);
        }
      });
    });
  });
})();
